"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LargeLanguageModelClient = exports.ChatCompletionMessage = exports.PromptRunProductArea = exports.ChatCompletionRole = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
const t = __importStar(require("io-ts"));
/**
 * The role of the message's author. One of `system`, `user`, `assistant`
 */
exports.ChatCompletionRole = (0, type_utils_1.makeEnum)({
    System: 'system',
    User: 'user',
    Assistant: 'assistant',
});
/**
 * The supported product areas where the prompts can be run
 */
var PromptRunProductArea;
(function (PromptRunProductArea) {
    PromptRunProductArea["Assessments"] = "assessments";
    PromptRunProductArea["ContractScanning"] = "contractScanning";
    PromptRunProductArea["PromptManager"] = "promptManager";
    PromptRunProductArea["UnstructuredDiscovery"] = "unstructuredDiscovery";
    PromptRunProductArea["DataInventory"] = "dataInventory";
    PromptRunProductArea["Pathfinder"] = "pathfinder";
})(PromptRunProductArea || (exports.PromptRunProductArea = PromptRunProductArea = {}));
exports.ChatCompletionMessage = t.type({
    role: (0, type_utils_1.valuesOf)(exports.ChatCompletionRole),
    content: t.string,
});
/**
 * LLM model clients
 */
exports.LargeLanguageModelClient = (0, type_utils_1.makeEnum)({
    OpenAi: 'openai',
    Claude: 'claude',
    Llama: 'llama',
});
//# sourceMappingURL=largeLanguageModels.js.map